import React, { useEffect, useState } from 'react';
import {
  ActionButton,
  BottomCont,
  ButtonCont,
  DescriptionText,
  InfoCont,
  Label,
  NoteCont,
  RefCont,
  RoleHeaderCont,
  RoleItemCont,
  TitleCont,
  TopCont,
  Wrapper,
} from './RoleItem.styles';
import RoleDetails from './RoleContent/RoleDetails';
import { ICastingRoleAttributes } from 'shared/interfaces/ICastingRole';
import { Hidden, IconButton, Grid, useTheme, Popover } from '@material-ui/core';
import { union } from 'lodash';
import { LuShare2 } from 'react-icons/lu';
import { COLORS } from 'shared/constants/COLORS';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { useHeaderContentParser } from './useHeaderContentParser';
import { CustomTooltip } from 'pages/Opportunities/components/CustomTooltip/CustomTooltip';
import { IRoleAttributes } from 'shared/interfaces/IRole';
import { OpportunitiesContext } from 'pages/Opportunities/context/OpportunitiesContext';
import { useContextSelector } from 'use-context-selector';
import { CONFIG } from 'shared/config';
import { CheckMarkIcon } from '@room-match/shared-ui-components';
const { DARK_GREEN_TEXT, DARK_GREEN_ICON } = COLORS;

interface Props {
  role: ICastingRoleAttributes | IRoleAttributes;
  projectId: string;
  companyName: string;
  type: 'new' | 'submitted' | 'not_interested';
  projectName: string;
  projectSlug: string;
  notYetSubmitted?: boolean;
}

const RoleItem: React.FC<Props> = ({
  role,
  projectId,
  notYetSubmitted,
  companyName,
  type,
  projectName,
  projectSlug,
}) => {
  const isDark = useTheme().palette.type === 'dark';
  const projectIds = useContextSelector(OpportunitiesContext, (state) => state.filters.project_ids);
  const openOpportunityModal = useContextSelector(OpportunitiesContext, (state) => state.openOpportunityModal);
  const {
    roleName,
    union,
    rate,
    submitBy,
    work,
    fittingDate,
    age,
    ageType,
    gender,
    ethnicities,
    location,
    roleDescription,
    roleMediaCount,
    workingNote,
    ethnic_appearance,
    genders,
  } = useHeaderContentParser(role);
  const [viewMore, setciewMore] = useState(Boolean(projectIds?.length && type === 'new'));
  const { id: roleId, slug } = role;

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const copyLink = (event: React.MouseEvent<HTMLButtonElement>) => {
    // if (anchorEl !== null) return;
    // //copy to clipboard
    // navigator.clipboard.writeText(`${CONFIG.JOBS_APP_URL}/${projectId}/${roleId}`);
    // setAnchorEl(event.currentTarget);
    // setTimeout(() => {
    //   handleClose();
    // }, 1500);
    openOpportunityModal('share', `${CONFIG.JOBS_APP_URL}/${projectSlug}/${slug}`, projectName, roleName);
  };

  // useEffect(() => {
  //   console.log('RoleItem Rendered', roleName);
  // });

  const expand = () => setciewMore((prev) => !prev);
  return (
    <RoleItemCont>
      <RoleHeaderCont>
        <TopCont>
          <TitleCont>
            <InfoCont width={230}>
              <CustomTypography fontWeight={500}>{roleName}</CustomTypography>
              <CustomTypography color="primary">{rate}</CustomTypography>
            </InfoCont>
            <Hidden lgUp>
              <ButtonCont>
                <IconButton onClick={copyLink}>
                  <LuShare2 color={COLORS.PRIMARY} size={22} />
                </IconButton>

                <ActionButton
                  fullWidth
                  variant="outlined"
                  onClick={expand}
                  style={{ color: isDark ? 'white' : COLORS.PRIMARY }}
                >
                  {viewMore ? 'View Less' : 'View More'}
                </ActionButton>
              </ButtonCont>
            </Hidden>
          </TitleCont>
          <Grid container spacing={2}>
            <Grid item lg={3} md={3} sm={5} container direction="row" style={{}} justifyContent="flex-start">
              <InfoCont width={100} bordered={1}>
                <Label>Submit by:</Label>
                <Label>Work:</Label>
                <Label>Fitting:</Label>
              </InfoCont>
              <InfoCont>
                <DescriptionText>{submitBy}</DescriptionText>
                <DescriptionText>{work}</DescriptionText>
                <DescriptionText>{fittingDate}</DescriptionText>
              </InfoCont>
            </Grid>
            <Grid item lg={5} md={5} sm={7} container direction="row" style={{}} justifyContent="flex-start">
              <InfoCont width={100}>
                <Label>Age:</Label>
                <Label>Gender:</Label>
                <Label>Ethnicities:</Label>
              </InfoCont>
              <InfoCont>
                <CustomTypography>
                  {age}
                  {ageType}
                </CustomTypography>
                <CustomTooltip title={genders?.join('\n')}>
                  <CustomTypography>{gender}</CustomTypography>
                </CustomTooltip>
                <CustomTooltip title={ethnic_appearance?.join('\n')}>
                  <DescriptionText>{ethnicities}</DescriptionText>
                </CustomTooltip>
              </InfoCont>
            </Grid>
            <Grid item lg={4} md={4} sm={12} container direction="row" justifyContent="flex-start">
              <InfoCont width={90} style={{ marginRight: 10 }}>
                <Label>Rate:</Label>
                <Label>Location:</Label>
              </InfoCont>
              <InfoCont width={500} style={{ minWidth: 'unset' }}>
                <CustomTooltip title={rate}>
                  <DescriptionText>{rate}</DescriptionText>
                </CustomTooltip>
                <CustomTooltip title={location}>
                  <DescriptionText>{location}</DescriptionText>
                </CustomTooltip>
              </InfoCont>
            </Grid>
          </Grid>

          <Hidden mdDown>
            <ButtonCont>
              <IconButton onClick={copyLink}>
                <LuShare2 color={COLORS.PRIMARY} size={22} />
              </IconButton>

              <ActionButton
                fullWidth
                variant="outlined"
                onClick={expand}
                style={{ color: isDark ? 'white' : COLORS.PRIMARY }}
              >
                {viewMore ? 'View Less' : 'View More'}
              </ActionButton>
            </ButtonCont>
          </Hidden>
        </TopCont>
        {!viewMore ? (
          <BottomCont>
            <RefCont>
              <Label>Reference Media:</Label>
              <CustomTypography color="primary">x{roleMediaCount}</CustomTypography>
            </RefCont>
            <NoteCont>
              <Wrapper>
                <Label>Description: </Label>
                <CustomTooltip title={roleDescription}>
                  <DescriptionText>{roleDescription}</DescriptionText>
                </CustomTooltip>
              </Wrapper>

              <Wrapper>
                <Label>Working Note:</Label>
                <CustomTooltip title={workingNote}>
                  <DescriptionText>{workingNote}</DescriptionText>
                </CustomTooltip>
              </Wrapper>
            </NoteCont>
          </BottomCont>
        ) : (
          <React.Fragment />
        )}
      </RoleHeaderCont>
      {viewMore ? (
        <RoleDetails
          notYetSubmitted={notYetSubmitted}
          type={type}
          roleName={roleName}
          roleId={roleId}
          roleDescription={roleDescription}
          workingNote={workingNote}
          projectId={projectId}
          companyName={companyName}
        />
      ) : (
        <React.Fragment />
      )}
      {open ? (
        <Popover
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={open}
        >
          <div style={{ padding: 10, display: 'flex', gap: 5, alignItems: 'center' }}>
            <CheckMarkIcon htmlColor={DARK_GREEN_ICON} fontSize="small" />
            <CustomTypography fontSize={14} style={{ color: DARK_GREEN_TEXT }} fontWeight={700}>
              Link Copied!
            </CustomTypography>
          </div>
        </Popover>
      ) : null}
    </RoleItemCont>
  );
};

export default React.memo(RoleItem);
